// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Top 3-col grid */
.aset__top-grid    { display:grid; grid-template-columns:repeat(3,1fr); gap:1.25rem; }
.aset__bottom-grid { display:grid; grid-template-columns:1fr 1fr; gap:1.25rem; }

/* Section card */
.aset__section { display:flex; flex-direction:column; gap:0; }
.aset__section-head { display:flex; align-items:center; gap:0.65rem; margin-bottom:1.25rem; padding-bottom:0.85rem; border-bottom:1px solid var(--admin-border); }
.aset__section-icon  { font-size:1.25rem; color:var(--admin-rust); flex-shrink:0; }
.aset__section-title { font-size:0.95rem; font-weight:700; color:var(--admin-text); margin:0; }
.aset__section-body  { display:flex; flex-direction:column; gap:0.85rem; }

/* Field */
.aset__field { display:flex; flex-direction:column; gap:0.35rem; }
.aset__label { font-size:0.8rem; font-weight:600; color:var(--admin-text); }
.aset__input-wrap { position:relative; display:flex; align-items:center; }
.aset__input {
  width:100%; border:1px solid var(--admin-border); border-radius:7px;
  background:#fff; padding:0.65rem 0.85rem;
  font-size:0.84rem; color:var(--admin-text); outline:none;
  font-family:var(--font-body); transition:border-color 0.15s;
  box-sizing:border-box;
}
.aset__input:focus { border-color:var(--admin-rust); box-shadow:0 0 0 3px rgba(var(--admin-rust-rgb), 0.08); }
.aset__input--mono { font-family:monospace; font-size:0.78rem; letter-spacing:0.02em; }
.aset__textarea { resize:vertical; min-height:80px; }
.aset__pw-toggle { position:absolute; right:0.5rem; background:none; border:none; cursor:pointer; font-size:0.95rem; color:var(--admin-muted); padding:0.2rem; min-width:32px; min-height:32px; display:inline-flex; align-items:center; justify-content:center; }
.aset__pw-toggle:hover { color:var(--admin-text); }

/* Select */
.aset__select-wrap { position:relative; }
.aset__select { width:100%; appearance:none; border:1px solid var(--admin-border); border-radius:7px; background:#fff; padding:0.65rem 2.25rem 0.65rem 0.85rem; font-size:0.84rem; color:var(--admin-text); outline:none; cursor:pointer; }
.aset__select:focus { border-color:var(--admin-rust); }

/* Toggle */
.aset__toggle-row { display:flex; align-items:center; justify-content:space-between; gap:1rem; padding:0.25rem 0; }
.aset__toggle-label { font-size:0.84rem; font-weight:600; color:var(--admin-text); margin:0 0 0.15rem; }
.aset__toggle-sub   { font-size:0.75rem; color:var(--admin-muted); margin:0; }

.aset__toggle {
  position:relative; width:2.75rem; height:1.5rem; border-radius:99px;
  background:var(--admin-border); border:none; cursor:pointer;
  flex-shrink:0; transition:background 0.2s;
  padding:0;
}
.aset__toggle--on { background:var(--admin-rust); }
.aset__toggle-thumb {
  position:absolute; top:3px; left:3px;
  width:1.125rem; height:1.125rem; border-radius:50%; background:#fff;
  box-shadow:0 1px 3px rgba(0,0,0,0.2);
  transition:transform 0.2s;
  display:block;
}
.aset__toggle--on .aset__toggle-thumb { transform:translateX(1.25rem); }

/* Social grid */
.aset__social-grid { display:flex; flex-direction:column; gap:0.65rem; }
.aset__social-row  { display:grid; grid-template-columns:140px 1fr; align-items:center; gap:0.85rem; }
.aset__social-label { font-size:0.8rem; font-weight:600; color:var(--admin-text); }
.aset__social-input { flex:1 1; }

/* Save bar */
.aset__save-bar { display:flex; align-items:center; gap:1rem; }
.aset__save-btn  { gap:0.5rem; }
.aset__save-msg  { font-size:0.82rem; color:var(--admin-muted); opacity:0; transition:opacity 0.3s; }
.aset__save-msg--visible { opacity:1; }

@media(max-width:1199px) {
  .aset__top-grid    { grid-template-columns:repeat(2,1fr); }
  .aset__bottom-grid { grid-template-columns:1fr; }
}
@media(max-width:767px) {
  .aset__top-grid    { grid-template-columns:1fr; }
  .aset__social-row  { grid-template-columns:1fr; }
}

/* ── SMTP section badge ── */
.aset__section-badge {
  margin-left: auto;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  background: rgba(var(--admin-rust-rgb), 0.1);
  color: var(--admin-rust-dk);
  padding: 0.2rem 0.6rem;
  border-radius: 99px;
  white-space: nowrap;
}

/* ── SMTP hint box ── */
.aset__smtp-hint {
  background: #faf7f2;
  border: 1px solid var(--admin-border);
  border-radius: 6px;
  padding: 0.75rem 0.9rem;
  margin-bottom: 0.5rem;
}
.aset__smtp-hint p {
  font-size: 0.78rem;
  color: var(--admin-muted);
  margin: 0;
  line-height: 1.6;
}
.aset__smtp-hint code {
  background: rgba(27,27,27,0.07);
  border-radius: 3px;
  padding: 0.1rem 0.35rem;
  font-family: monospace;
  font-size: 0.78rem;
  color: var(--admin-text);
}

/* ── SMTP Test Panel ── */
.aset__smtp-test {
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px dashed var(--admin-border);
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.aset__smtp-test-head {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
}

.aset__smtp-test-icon {
  font-size: 1.1rem;
  color: var(--admin-rust);
  flex-shrink: 0;
  margin-top: 2px;
}

.aset__smtp-test-title {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.15rem;
}

.aset__smtp-test-sub {
  font-size: 0.75rem;
  color: var(--admin-muted);
  margin: 0;
  line-height: 1.45;
}

.aset__smtp-test-row {
  display: flex;
  gap: 0.6rem;
  align-items: center;
}

/* Result */
.aset__smtp-result {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 0.85rem;
  border-radius: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  animation: slideDown 0.2s ease;
}

.aset__smtp-result--ok {
  background: rgba(22,163,74,0.08);
  border: 1px solid rgba(22,163,74,0.25);
  color: #16a34a;
}

.aset__smtp-result--err {
  background: rgba(220,38,38,0.07);
  border: 1px solid rgba(220,38,38,0.2);
  color: #dc2626;
}

.aset__result-icon { font-size: 1.1rem; flex-shrink: 0; }

/* SMTP info grid */
.aset__smtp-info {
  background: #faf7f2;
  border-radius: 6px;
  padding: 0.75rem;
}

.aset__smtp-info-label {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--admin-muted);
  margin: 0 0 0.5rem;
}

.aset__smtp-info-grid {
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 0.25rem 0.75rem;
  font-size: 0.75rem;
}

.aset__smtp-info-grid span { color: var(--admin-muted); }
.aset__smtp-info-grid strong { color: var(--admin-text); font-weight: 600; word-break: break-all; }

/* Save bar improvements */
.aset__save-ok {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.84rem;
  font-weight: 600;
  color: #16a34a;
  animation: slideDown 0.2s ease;
}

.aset__save-err {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.84rem;
  font-weight: 600;
  color: #dc2626;
}

.aset__save-hint {
  font-size: 0.75rem;
  color: var(--admin-muted);
  margin: 0 0 0 auto;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ── Password "Saved" state ── */
.aset__pw-saved {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.6rem 0.85rem;
  border: 1px solid var(--admin-border);
  border-radius: 7px;
  background: #faf7f2;
}

.aset__pw-saved-left {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.aset__pw-saved-dots {
  font-size: 0.75rem;
  letter-spacing: 0.12em;
  color: var(--admin-muted);
  font-family: monospace;
}

.aset__pw-saved-label {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #166534;
  background: rgba(22,163,74,0.1);
  padding: 0.15rem 0.5rem;
  border-radius: 99px;
}

.aset__pw-saved-label::before {
  content: "✓";
}

.aset__pw-change-btn {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--admin-rust);
  background: none;
  border: 1.5px solid var(--admin-rust);
  border-radius: 5px;
  padding: 0.3rem 0.75rem;
  cursor: pointer;
  transition: background 0.15s;
  flex-shrink: 0;
}

.aset__pw-change-btn:hover {
  background: rgba(var(--admin-rust-rgb), 0.07);
}

/* Explains that blank means "use the server's own SMTP settings" — which
   is not obvious, and getting it wrong stops all outgoing mail. */
.aset__note {
  font-size: 0.82rem;
  line-height: 1.6;
  color: var(--admin-muted);
  background: rgba(var(--admin-rust-rgb), 0.07);
  border-radius: 8px;
  padding: 0.7rem 0.9rem;
  margin: 0 0 1.1rem;
}

/* A line of guidance under a settings card's fields. */
.aset__hint {
  margin: 0.6rem 0 0;
  font-size: 0.78rem;
  color: #6b6258;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/admin/AdminSettings.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB,qBAAqB,YAAY,EAAE,mCAAmC,EAAE,WAAW,EAAE;AACrF,qBAAqB,YAAY,EAAE,6BAA6B,EAAE,WAAW,EAAE;;AAE/E,iBAAiB;AACjB,iBAAiB,YAAY,EAAE,qBAAqB,EAAE,KAAK,EAAE;AAC7D,sBAAsB,YAAY,EAAE,kBAAkB,EAAE,WAAW,EAAE,qBAAqB,EAAE,sBAAsB,EAAE,2CAA2C,EAAE;AACjK,uBAAuB,iBAAiB,EAAE,uBAAuB,EAAE,aAAa,EAAE;AAClF,uBAAuB,iBAAiB,EAAE,eAAe,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AAC9F,uBAAuB,YAAY,EAAE,qBAAqB,EAAE,WAAW,EAAE;;AAEzE,UAAU;AACV,eAAe,YAAY,EAAE,qBAAqB,EAAE,WAAW,EAAE;AACjE,eAAe,gBAAgB,EAAE,eAAe,EAAE,uBAAuB,EAAE;AAC3E,oBAAoB,iBAAiB,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACzE;EACE,UAAU,EAAE,oCAAoC,EAAE,iBAAiB;EACnE,eAAe,EAAE,uBAAuB;EACxC,iBAAiB,EAAE,uBAAuB,EAAE,YAAY;EACxD,4BAA4B,EAAE,6BAA6B;EAC3D,qBAAqB;AACvB;AACA,qBAAqB,8BAA8B,EAAE,sDAAsD,EAAE;AAC7G,qBAAqB,qBAAqB,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AACtF,kBAAkB,eAAe,EAAE,eAAe,EAAE;AACpD,mBAAmB,iBAAiB,EAAE,YAAY,EAAE,eAAe,EAAE,WAAW,EAAE,cAAc,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE;AACjQ,yBAAyB,uBAAuB,EAAE;;AAElD,WAAW;AACX,qBAAqB,iBAAiB,EAAE;AACxC,gBAAgB,UAAU,EAAE,eAAe,EAAE,oCAAoC,EAAE,iBAAiB,EAAE,eAAe,EAAE,uCAAuC,EAAE,iBAAiB,EAAE,uBAAuB,EAAE,YAAY,EAAE,cAAc,EAAE;AAC1O,sBAAsB,8BAA8B,EAAE;;AAEtD,WAAW;AACX,oBAAoB,YAAY,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,QAAQ,EAAE,iBAAiB,EAAE;AAClH,sBAAsB,iBAAiB,EAAE,eAAe,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AACvG,sBAAsB,iBAAiB,EAAE,wBAAwB,EAAE,QAAQ,EAAE;;AAE7E;EACE,iBAAiB,EAAE,aAAa,EAAE,aAAa,EAAE,kBAAkB;EACnE,8BAA8B,EAAE,WAAW,EAAE,cAAc;EAC3D,aAAa,EAAE,0BAA0B;EACzC,SAAS;AACX;AACA,oBAAoB,4BAA4B,EAAE;AAClD;EACE,iBAAiB,EAAE,OAAO,EAAE,QAAQ;EACpC,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE,eAAe;EACnE,oCAAoC;EACpC,yBAAyB;EACzB,aAAa;AACf;AACA,wCAAwC,6BAA6B,EAAE;;AAEvE,gBAAgB;AAChB,qBAAqB,YAAY,EAAE,qBAAqB,EAAE,WAAW,EAAE;AACvE,qBAAqB,YAAY,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,WAAW,EAAE;AACrG,sBAAsB,gBAAgB,EAAE,eAAe,EAAE,uBAAuB,EAAE;AAClF,sBAAsB,QAAM,EAAE;;AAE9B,aAAa;AACb,kBAAkB,YAAY,EAAE,kBAAkB,EAAE,QAAQ,EAAE;AAC9D,mBAAmB,UAAU,EAAE;AAC/B,mBAAmB,iBAAiB,EAAE,wBAAwB,EAAE,SAAS,EAAE,uBAAuB,EAAE;AACpG,2BAA2B,SAAS,EAAE;;AAEtC;EACE,qBAAqB,mCAAmC,EAAE;EAC1D,qBAAqB,yBAAyB,EAAE;AAClD;AACA;EACE,qBAAqB,yBAAyB,EAAE;EAChD,qBAAqB,yBAAyB,EAAE;AAClD;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,4CAA4C;EAC5C,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,cAAc;AAChB;;AAEA,qBAAqB,iBAAiB,EAAE,cAAc,EAAE;;AAExD,mBAAmB;AACnB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,6BAA6B,yBAAyB,EAAE;AACxD,+BAA+B,wBAAwB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;;AAElG,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;kEACkE;AAClE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Top 3-col grid */\n.aset__top-grid    { display:grid; grid-template-columns:repeat(3,1fr); gap:1.25rem; }\n.aset__bottom-grid { display:grid; grid-template-columns:1fr 1fr; gap:1.25rem; }\n\n/* Section card */\n.aset__section { display:flex; flex-direction:column; gap:0; }\n.aset__section-head { display:flex; align-items:center; gap:0.65rem; margin-bottom:1.25rem; padding-bottom:0.85rem; border-bottom:1px solid var(--admin-border); }\n.aset__section-icon  { font-size:1.25rem; color:var(--admin-rust); flex-shrink:0; }\n.aset__section-title { font-size:0.95rem; font-weight:700; color:var(--admin-text); margin:0; }\n.aset__section-body  { display:flex; flex-direction:column; gap:0.85rem; }\n\n/* Field */\n.aset__field { display:flex; flex-direction:column; gap:0.35rem; }\n.aset__label { font-size:0.8rem; font-weight:600; color:var(--admin-text); }\n.aset__input-wrap { position:relative; display:flex; align-items:center; }\n.aset__input {\n  width:100%; border:1px solid var(--admin-border); border-radius:7px;\n  background:#fff; padding:0.65rem 0.85rem;\n  font-size:0.84rem; color:var(--admin-text); outline:none;\n  font-family:var(--font-body); transition:border-color 0.15s;\n  box-sizing:border-box;\n}\n.aset__input:focus { border-color:var(--admin-rust); box-shadow:0 0 0 3px rgba(var(--admin-rust-rgb), 0.08); }\n.aset__input--mono { font-family:monospace; font-size:0.78rem; letter-spacing:0.02em; }\n.aset__textarea { resize:vertical; min-height:80px; }\n.aset__pw-toggle { position:absolute; right:0.5rem; background:none; border:none; cursor:pointer; font-size:0.95rem; color:var(--admin-muted); padding:0.2rem; min-width:32px; min-height:32px; display:inline-flex; align-items:center; justify-content:center; }\n.aset__pw-toggle:hover { color:var(--admin-text); }\n\n/* Select */\n.aset__select-wrap { position:relative; }\n.aset__select { width:100%; appearance:none; border:1px solid var(--admin-border); border-radius:7px; background:#fff; padding:0.65rem 2.25rem 0.65rem 0.85rem; font-size:0.84rem; color:var(--admin-text); outline:none; cursor:pointer; }\n.aset__select:focus { border-color:var(--admin-rust); }\n\n/* Toggle */\n.aset__toggle-row { display:flex; align-items:center; justify-content:space-between; gap:1rem; padding:0.25rem 0; }\n.aset__toggle-label { font-size:0.84rem; font-weight:600; color:var(--admin-text); margin:0 0 0.15rem; }\n.aset__toggle-sub   { font-size:0.75rem; color:var(--admin-muted); margin:0; }\n\n.aset__toggle {\n  position:relative; width:2.75rem; height:1.5rem; border-radius:99px;\n  background:var(--admin-border); border:none; cursor:pointer;\n  flex-shrink:0; transition:background 0.2s;\n  padding:0;\n}\n.aset__toggle--on { background:var(--admin-rust); }\n.aset__toggle-thumb {\n  position:absolute; top:3px; left:3px;\n  width:1.125rem; height:1.125rem; border-radius:50%; background:#fff;\n  box-shadow:0 1px 3px rgba(0,0,0,0.2);\n  transition:transform 0.2s;\n  display:block;\n}\n.aset__toggle--on .aset__toggle-thumb { transform:translateX(1.25rem); }\n\n/* Social grid */\n.aset__social-grid { display:flex; flex-direction:column; gap:0.65rem; }\n.aset__social-row  { display:grid; grid-template-columns:140px 1fr; align-items:center; gap:0.85rem; }\n.aset__social-label { font-size:0.8rem; font-weight:600; color:var(--admin-text); }\n.aset__social-input { flex:1; }\n\n/* Save bar */\n.aset__save-bar { display:flex; align-items:center; gap:1rem; }\n.aset__save-btn  { gap:0.5rem; }\n.aset__save-msg  { font-size:0.82rem; color:var(--admin-muted); opacity:0; transition:opacity 0.3s; }\n.aset__save-msg--visible { opacity:1; }\n\n@media(max-width:1199px) {\n  .aset__top-grid    { grid-template-columns:repeat(2,1fr); }\n  .aset__bottom-grid { grid-template-columns:1fr; }\n}\n@media(max-width:767px) {\n  .aset__top-grid    { grid-template-columns:1fr; }\n  .aset__social-row  { grid-template-columns:1fr; }\n}\n\n/* ── SMTP section badge ── */\n.aset__section-badge {\n  margin-left: auto;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  background: rgba(var(--admin-rust-rgb), 0.1);\n  color: var(--admin-rust-dk);\n  padding: 0.2rem 0.6rem;\n  border-radius: 99px;\n  white-space: nowrap;\n}\n\n/* ── SMTP hint box ── */\n.aset__smtp-hint {\n  background: #faf7f2;\n  border: 1px solid var(--admin-border);\n  border-radius: 6px;\n  padding: 0.75rem 0.9rem;\n  margin-bottom: 0.5rem;\n}\n.aset__smtp-hint p {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  margin: 0;\n  line-height: 1.6;\n}\n.aset__smtp-hint code {\n  background: rgba(27,27,27,0.07);\n  border-radius: 3px;\n  padding: 0.1rem 0.35rem;\n  font-family: monospace;\n  font-size: 0.78rem;\n  color: var(--admin-text);\n}\n\n/* ── SMTP Test Panel ── */\n.aset__smtp-test {\n  margin-top: 1.25rem;\n  padding-top: 1.25rem;\n  border-top: 1px dashed var(--admin-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.aset__smtp-test-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n}\n\n.aset__smtp-test-icon {\n  font-size: 1.1rem;\n  color: var(--admin-rust);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.aset__smtp-test-title {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.15rem;\n}\n\n.aset__smtp-test-sub {\n  font-size: 0.75rem;\n  color: var(--admin-muted);\n  margin: 0;\n  line-height: 1.45;\n}\n\n.aset__smtp-test-row {\n  display: flex;\n  gap: 0.6rem;\n  align-items: center;\n}\n\n/* Result */\n.aset__smtp-result {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.65rem 0.85rem;\n  border-radius: 6px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  animation: slideDown 0.2s ease;\n}\n\n.aset__smtp-result--ok {\n  background: rgba(22,163,74,0.08);\n  border: 1px solid rgba(22,163,74,0.25);\n  color: #16a34a;\n}\n\n.aset__smtp-result--err {\n  background: rgba(220,38,38,0.07);\n  border: 1px solid rgba(220,38,38,0.2);\n  color: #dc2626;\n}\n\n.aset__result-icon { font-size: 1.1rem; flex-shrink: 0; }\n\n/* SMTP info grid */\n.aset__smtp-info {\n  background: #faf7f2;\n  border-radius: 6px;\n  padding: 0.75rem;\n}\n\n.aset__smtp-info-label {\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--admin-muted);\n  margin: 0 0 0.5rem;\n}\n\n.aset__smtp-info-grid {\n  display: grid;\n  grid-template-columns: 60px 1fr;\n  gap: 0.25rem 0.75rem;\n  font-size: 0.75rem;\n}\n\n.aset__smtp-info-grid span { color: var(--admin-muted); }\n.aset__smtp-info-grid strong { color: var(--admin-text); font-weight: 600; word-break: break-all; }\n\n/* Save bar improvements */\n.aset__save-ok {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.84rem;\n  font-weight: 600;\n  color: #16a34a;\n  animation: slideDown 0.2s ease;\n}\n\n.aset__save-err {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.84rem;\n  font-weight: 600;\n  color: #dc2626;\n}\n\n.aset__save-hint {\n  font-size: 0.75rem;\n  color: var(--admin-muted);\n  margin: 0 0 0 auto;\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* ── Password \"Saved\" state ── */\n.aset__pw-saved {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.6rem 0.85rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 7px;\n  background: #faf7f2;\n}\n\n.aset__pw-saved-left {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.aset__pw-saved-dots {\n  font-size: 0.75rem;\n  letter-spacing: 0.12em;\n  color: var(--admin-muted);\n  font-family: monospace;\n}\n\n.aset__pw-saved-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #166534;\n  background: rgba(22,163,74,0.1);\n  padding: 0.15rem 0.5rem;\n  border-radius: 99px;\n}\n\n.aset__pw-saved-label::before {\n  content: \"✓\";\n}\n\n.aset__pw-change-btn {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--admin-rust);\n  background: none;\n  border: 1.5px solid var(--admin-rust);\n  border-radius: 5px;\n  padding: 0.3rem 0.75rem;\n  cursor: pointer;\n  transition: background 0.15s;\n  flex-shrink: 0;\n}\n\n.aset__pw-change-btn:hover {\n  background: rgba(var(--admin-rust-rgb), 0.07);\n}\n\n/* Explains that blank means \"use the server's own SMTP settings\" — which\n   is not obvious, and getting it wrong stops all outgoing mail. */\n.aset__note {\n  font-size: 0.82rem;\n  line-height: 1.6;\n  color: var(--admin-muted);\n  background: rgba(var(--admin-rust-rgb), 0.07);\n  border-radius: 8px;\n  padding: 0.7rem 0.9rem;\n  margin: 0 0 1.1rem;\n}\n\n/* A line of guidance under a settings card's fields. */\n.aset__hint {\n  margin: 0.6rem 0 0;\n  font-size: 0.78rem;\n  color: #6b6258;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
